import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { MinimumPaymentDateModel } from '../../Models/Models/Payments/Withdrawals/MinimumPaymentDateModel';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class MinimumPaymentDateClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, asAt: IJsonDate, isCrystallisationDisinvestmentRequired: boolean, isIncomeDisinvestmentRequired: boolean, method: string, arrangementId: number): Promise<MinimumPaymentDateModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Payments/MinimumPaymentDate/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, asAt: asAt, isCrystallisationDisinvestmentRequired: isCrystallisationDisinvestmentRequired, isIncomeDisinvestmentRequired: isIncomeDisinvestmentRequired, method: method, arrangementId: arrangementId }

    return AjaxWrapper.get<MinimumPaymentDateModel, any>(url, data);
  }
}

